import ZRadioGroup from '../radio/radio-group.vue'

ZRadioGroup.install = function(app) {
  app.component(ZRadioGroup.name, ZRadioGroup)
}

export default ZRadioGroup